// src/pages/MainList.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { GrInstagram } from "react-icons/gr";
import { SiGmail } from "react-icons/si";
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import { IoIosArrowDown } from 'react-icons/io';
import Modal from '../Common/Modal';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import {
  FaPlay,
  FaDownload,
  FaWindows,
  FaLinux,
  FaApple,
} from 'react-icons/fa';
import { TbDownload } from 'react-icons/tb';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Loader from '../Common/Loader';

const decodeLanguage = (code) => {
  if (!code) return '';
  let decoded = "";
  const c = code.toLowerCase();
  if (c.includes("h")) decoded += "Hindi • ";
  if (c.includes("e")) decoded += "English • ";
  if (c.includes("t")) decoded += "Tamil • ";
  if (c.includes("b")) decoded += "Bengali • ";
  if (c.includes("o")) decoded += "Odia • ";
  if (c.includes("k")) decoded += "Kannada • ";
  if (c.includes("u")) decoded += "Telugu • ";
  if (c.includes("l")) decoded += "Malayalam • ";
  if (c.includes("m")) decoded += "Marathi • ";
  if (c.includes("p")) decoded += "Punjabi • ";
  if (c.includes("g")) decoded += "Gujarati • ";

  if (c.includes("c")) decoded += "Chinese • ";
  if (c.includes("r")) decoded += "Korean • ";
  if (c.includes("a")) decoded += "Thai • ";
  if (c.includes("j")) decoded += "Japanese • ";
  if (c.includes("f")) decoded += "Filipino • ";
  if (c.includes("d")) decoded += "Indonesian • ";
  if (c.includes("s")) decoded += "Spanish • ";
  if (c.includes("i")) decoded += "Italian • ";
  if (c.includes("n")) decoded += "French • ";
  if (c.includes("y")) decoded += "German • ";
  if (c.includes("q")) decoded += "Romanian • ";
  if (c.includes("w")) decoded += "Swedish • ";
  if (c.includes("z")) decoded += "Turkish • ";

  if (c.includes("0")) decoded += "Arabic • ";
  if (c.includes("v")) decoded += "Persian • ";
  if (c.includes("2")) decoded += "Danish • ";
  if (c.includes("4")) decoded += "Urdu • ";
  if (c.includes("5")) decoded += "Czech • ";
  if (c.includes("6")) decoded += "Dutch • ";
  if (c.includes("7")) decoded += "Portuguese • ";
  if (c.includes("8")) decoded += "Russian • ";
  if (c.includes("9")) decoded += "Norwegian • ";
  if (c.includes("+")) decoded += "Polish • ";
  if (c.includes("3")) decoded += "Igbo • ";
  if (c.includes("1")) decoded += "Finnish • ";
  if (c.includes("*")) decoded += "Zulu • ";
  if (c.includes("~")) decoded += "Vietnamese • ";

  return decoded ? decoded.slice(0, -3) : '';
};

const decodeGenre = (code) => {
  if (!code) return '';
  let decoded = "";
  const c = code.toLowerCase();
  if (c.includes("a")) decoded += "Action • ";
  if (c.includes("h")) decoded += "Horror • ";
  if (c.includes("d")) decoded += "Adventure • ";
  if (c.includes("r")) decoded += "Romance • ";
  if (c.includes("c")) decoded += "Comedy • ";
  if (c.includes("m")) decoded += "Drama • ";
  if (c.includes("n")) decoded += "Animation • ";
  if (c.includes("i")) decoded += "Crime • ";
  if (c.includes("y")) decoded += "Mystery • ";
  if (c.includes("f")) decoded += "Fantasy • ";
  if (c.includes("o")) decoded += "Sci-Fi • ";
  if (c.includes("t")) decoded += "Thriller • ";
  if (c.includes("s")) decoded += "History • ";
  if (c.includes("l")) decoded += "Family • ";
  if (c.includes("u")) decoded += "Documentary • ";
  if (c.includes("b")) decoded += "Biography • ";
  if (c.includes("e")) decoded += "Music • ";
  if (c.includes("p")) decoded += "Sports • ";
  if (c.includes("w")) decoded += "Western • ";
  if (c.includes("g")) decoded += "War • ";
  if (c.includes("j")) decoded += "News • ";
  if (c.includes("x")) decoded += "Adult • ";
  return decoded ? decoded.slice(0, -3) : '';
};

const MainList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [myData, setMyData] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSeasonListVisible, setIsSeasonListVisible] = useState(false);
  const [selectedEpisodes, setSelectedEpisodes] = useState('');
  const [selectedQuality, setSelectedQuality] = useState('');
  const [loader, setLoader] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [buttonData, setButtonData] = useState({});
  const scrollRef = useRef(null);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [showRedirectButton, setShowRedirectButton] = useState(false);
  const [loadingAction, setLoadingAction] = useState(null); // 'watch' or 'download' or null
  // New states for SID token handling
  const [sidToken, setSidToken] = useState(null);
  const [sidwToken, setSidwToken] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadResponse, setDownloadResponse] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [showGuide, setShowGuide] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [modalOpen, setModalOpen] = useState(false);
  const [responseCode, setResponseCode] = useState(null);

  useEffect(() => {
    // Check for sid and sidw tokens in URL
    const searchParams = new URLSearchParams(location.search);
    const downloadToken = searchParams.get('sid');
    const watchToken = searchParams.get('sidw');

    if (downloadToken) {
      setSidToken(downloadToken);
    }
    if (watchToken) {
      setSidwToken(watchToken);
    }

    const getData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          'https://customizebychoice.com/pikchar_api/web/getmoviedata',
          { code: id }
        );
        if (response.data && response.data.moviedata) {
          setMyData(response.data.moviedata);
          // default season select for series if seasons exist
          if (response.data.moviedata.seasons && response.data.moviedata.seasons > 0) {
            setSelectedSeason(0);
          } else {
            setSelectedSeason(null);
          }
        } else {
          setMyData(null);
        }
      } catch (error) {
        setResponseCode(error.response?.status || 'Unknown Error');
        setModalOpen(true);
        setMyData(null);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [id, location.search]);

  const handleSeasonChange = (event) => {
    const seasonValue = event.target.getAttribute('data-value');
    const seasonIndex = seasonValue === 'clear' ? null : parseInt(seasonValue, 10);
    if (seasonIndex === null || isNaN(seasonIndex)) {
      setSelectedSeason(null);
    } else {
      setSelectedSeason(seasonIndex);
    }
    setIsSeasonListVisible(false);
  };

  const toggleSeasonList = () => {
    setIsSeasonListVisible((prev) => !prev);
  };

  const handleQualityClick = (quality) => {
    setSelectedQuality(quality);
    setButtonData({ type: 'quality', code: id, quality });
    setShowButtons(true);
  };

  const getQualityDisplay = (quality) => {
    switch (quality) {
      case 'q720':
        return '720p';
      case 'q480':
        return '480p';
      case 'q1080':
        return '1080p';
      default:
        return '';
    }
  };

  const handleEpisodeClick = (seasonIndex, episodeIndex) => {
    setSelectedEpisodes(episodeIndex);
    setButtonData({ type: 'episode', code: id, seasonIndex, episodeIndex });
    setShowButtons(true);
  };

  // Function to handle download with SID token
  const handleTokenDownload = async () => {
    setIsDownloading(true);
    setDownloadResponse(null);

    try {
      const response = await axios.post(
        'https://customizebychoice.com/pikchar_api/web/getDownloadLinkFromToken',
        { token: sidToken },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (response.status === 200 && response.data?.downloadUrl) {
        setDownloadResponse({
          success: true,
          downloadUrl: response.data.downloadUrl,
          message: 'Download ready!'
        });

        // Start download automatically
        window.location.href = response.data.downloadUrl;
      } else {
        setDownloadResponse({
          error: true,
          message: 'Failed to get download link. Please try again.'
        });
      }
    } catch (error) {
      console.error('Download failed:', error);
      setDownloadResponse({
        error: true,
        message: error.response?.data?.message || 'Download failed. Please try again.'
      });
    } finally {
      setIsDownloading(false);
    }
  };

  // Function to handle watch with SIDW token
  const handleTokenWatch = async () => {
    setIsDownloading(true);
    setDownloadResponse(null);
    setVideoUrl(null);

    try {
      const response = await axios.post(
        'https://customizebychoice.com/pikchar_api/web/getDownloadLinkFromToken',
        { token: sidwToken },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      if (response.status === 200 && response.data?.downloadUrl) {
        setVideoUrl(response.data.downloadUrl);
        setDownloadResponse({
          success: true,
          message: 'Video loaded successfully!'
        });
      } else {
        setDownloadResponse({
          error: true,
          message: 'Failed to load video. Please try again.'
        });
      }
    } catch (error) {
      console.error('Watch failed:', error);
      setDownloadResponse({
        error: true,
        message: error.response?.data?.message || 'Failed to load video. Please try again.'
      });
    } finally {
      setIsDownloading(false);
    }
  };

  const handleModalAction = async (action) => {
    setShowButtons(true);
    setRedirectUrl(null);
    setShowRedirectButton(false);
    setLoadingAction(action); // Set which button is loading

    //---------- WATCH ----------
    if (action === 'watch') {
      try {
        let payload = { code: buttonData.code };

        if (buttonData.type === 'quality') {
          payload.type = 'quality';
          payload.quality = buttonData.quality;
        }
        else if (buttonData.type === 'episode') {
          payload.type = 'episode';
          payload.seasonIndex = (buttonData.seasonIndex ?? 0) + 1;
          payload.episodeIndex = (buttonData.episodeIndex ?? 0) + 1;
        }
        payload.action = "watch";

        const response = await axiosPrivate.post(
          '/web/getwatchtoken',
          payload,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (response.status !== 200 || !response.data?.token) {
          throw new Error('Token generation failed');
        }

        const blogUrl = `https://www.customizebychoice.com/?sid=${response.data.token}`;

        // Try to open directly first
        const newWindow = window.open(blogUrl, '_blank', 'noopener,noreferrer');

        // If blocked, show button
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          setRedirectUrl(blogUrl);
          setShowRedirectButton(true);
        }

        setLoadingAction(null); // Clear loading state

      } catch (err) {
        console.error(err);
        setLoadingAction(null); // Clear loading state
        setResponseCode(403);
        setModalOpen(true);
      }
    }

    // ---------- DOWNLOAD ----------
    else if (action === 'download') {
      try {
        let payload = { code: buttonData.code };

        if (buttonData.type === 'quality') {
          payload.type = 'quality';
          payload.quality = buttonData.quality;
        }
        else if (buttonData.type === 'episode') {
          payload.type = 'episode';
          payload.seasonIndex = (buttonData.seasonIndex ?? 0) + 1;
          payload.episodeIndex = (buttonData.episodeIndex ?? 0) + 1;
        }
        payload.action = "download";

        const response = await axiosPrivate.post(
          '/web/getwatchtoken',
          payload,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (response.status !== 200 || !response.data?.token) {
          throw new Error('Token generation failed');
        }

        const blogUrl = `https://www.customizebychoice.com/?sid=${response.data.token}`;

        // Try to open directly first
        const newWindow = window.open(blogUrl, '_blank', 'noopener,noreferrer');

        // If blocked, show button
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          setRedirectUrl(blogUrl);
          setShowRedirectButton(true);
        }

        setLoadingAction(null); // Clear loading state

      } catch (err) {
        console.error(err);
        setLoadingAction(null); // Clear loading state
        setResponseCode(403);
        setModalOpen(true);
      }
    }
  };

  useEffect(() => {
    if (showButtons && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [showButtons]);

  // If not loading and no data, show 404
  if (!loading && !myData) {
    return <div className='flex justify-center items-center'>404 page not found</div>;
  }

  // decoded labels
  const genreLabel = myData ? decodeGenre(myData.genre) : '';
  const languageLabel = myData ? decodeLanguage(myData.lang) : '';

  // Render watch view if SIDW token is present
  if (sidwToken) {
    return (
      <div className='text-white min-h-screen bg-gradient-to-b from-black via-gray-900 to-black'>

        <a
          href="https://pikchar.xyz"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed top-4 right-4 z-[9999]
             bg-purple-600 text-white
             px-4 py-2 rounded-md
             text-sm md:text-base font-semibold
             hover:bg-purple-700
             shadow-lg transition"
        >
          Backup – pikchar.xyz
        </a>

        {loader || isDownloading ? (
          <div className='h-screen flex justify-center items-center'>
            <div className='w-48'>
              <Loader />
            </div>
          </div>
        ) : (
          <div className='max-w-7xl mx-auto px-4 py-12'>
            {/* Main Content Card */}
            <div className='bg-gradient-to-br from-gray-800/40 to-gray-900/40 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-gray-700/50'>
              {/* Header Section with Poster and Info */}
              <div className='flex flex-col md:flex-row gap-8 p-8 md:p-12'>
                {/* Poster */}
                <div className='flex-shrink-0 mx-auto md:mx-0'>
                  {loading ? (
                    <div className='w-56 h-80 md:w-72 md:h-[420px] rounded-xl'>
                      <Skeleton width='100%' height='100%' baseColor='#3F3F3F' />
                    </div>
                  ) : (
                    <img
                      src={myData?.poster}
                      alt={myData?.name || 'poster'}
                      className='w-56 h-80 md:w-72 md:h-[420px] object-cover rounded-xl shadow-2xl ring-4 ring-gray-700/50'
                    />
                  )}
                </div>

                {/* Movie Info */}
                <div className='flex-1 flex flex-col justify-center text-center md:text-left'>
                  {loading ? (
                    <>
                      <Skeleton height={60} width='90%' className='mb-6' baseColor='#3F3F3F' />
                      <Skeleton height={30} width='70%' className='mb-3' baseColor='#3F3F3F' />
                      <Skeleton height={30} width='70%' baseColor='#3F3F3F' />
                    </>
                  ) : (
                    <>
                      <h1 className='text-3xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent leading-tight'>
                        {myData?.name}
                      </h1>
                      <div className='space-y-3 mb-8'>
                        <div className='flex items-center gap-2 justify-center md:justify-start'>
                          <span className='text-yellow-400 text-sm font-semibold uppercase tracking-wider'>Genre:</span>
                          <p className='text-lg md:text-xl text-yellow-300/90 font-medium'>
                            {genreLabel}
                          </p>
                        </div>
                        <div className='flex items-center gap-2 justify-center md:justify-start'>
                          <span className='text-green-400 text-sm font-semibold uppercase tracking-wider'>Language:</span>
                          <p className='text-lg md:text-xl text-green-400/90 font-medium'>
                            {languageLabel}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Divider */}
              <div className='h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent'></div>

              {/* Watch Section */}
              <div className='p-8 md:p-12'>
                {!videoUrl ? (
                  <div className='text-center max-w-2xl mx-auto'>
                    <h2 className='text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent'>
                      Ready to Watch
                    </h2>
                    <p className='text-gray-300 text-lg mb-10'>
                      Your content is ready. Click the button below to start watching
                    </p>

                    {!downloadResponse && (
                      <button
                        onClick={handleTokenWatch}
                        disabled={isDownloading}
                        className='bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-bold px-16 py-5 rounded-xl transition-all shadow-xl shadow-blue-600/30 text-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-4 mx-auto transform hover:scale-105 duration-200'
                      >
                        {isDownloading ? (
                          <>
                            <div className='animate-spin rounded-full h-7 w-7 border-b-3 border-white'></div>
                            Loading...
                          </>
                        ) : (
                          <>
                            <FaPlay className='text-2xl' />
                            Watch Now
                          </>
                        )}
                      </button>
                    )}

                    {downloadResponse && downloadResponse.error && (
                      <div className='mt-8 p-8 rounded-xl shadow-xl bg-gradient-to-br from-red-900/60 to-red-800/60 border-2 border-red-500/50'>
                        <div className='bg-red-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4'>
                          <span className='text-white text-3xl font-bold'>✗</span>
                        </div>
                        <h4 className='text-2xl font-bold mb-3 text-red-300'>Loading Failed</h4>
                        <p className='text-red-200 mb-6 text-lg'>{downloadResponse.message}</p>
                        <button
                          onClick={handleTokenWatch}
                          className='bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-4 rounded-lg transition-all shadow-lg'
                        >
                          Try Again
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='w-full'>
                    <div className='mb-6'>
                      <h2 className='text-2xl md:text-3xl font-bold text-center bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent'>
                        Now Playing
                      </h2>
                    </div>

                    {/* Video Player */}
                    <div className='relative w-full' style={{ paddingTop: '56.25%' }}>
                      <video
                        className='absolute top-0 left-0 w-full h-full rounded-lg shadow-2xl'
                        controls
                        autoPlay
                        controlsList='nodownload'
                        onContextMenu={(e) => e.preventDefault()}
                      >
                        <source src={videoUrl} type='video/mp4' />
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    {downloadResponse && downloadResponse.success && (
                      <div className='mt-6 p-6 rounded-xl bg-gradient-to-br from-green-900/40 to-emerald-900/40 border border-green-500/30 text-center'>
                        <p className='text-green-300 text-lg'>
                          <span className='text-2xl mr-2'>✓</span>
                          {downloadResponse.message}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {modalOpen && (
          <Modal statusCode={responseCode} onClose={() => setModalOpen(false)} />
        )}
      </div>
    );
  }

  // Render download view if SID token is present
  if (sidToken) {
    return (
      <div className='text-white min-h-screen bg-gradient-to-b from-black via-gray-900 to-black'>

        <a
          href="https://pikchar.xyz"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed top-4 right-4 z-[9999]
             bg-purple-600 text-white
             px-4 py-2 rounded-md
             text-sm md:text-base font-semibold
             hover:bg-purple-700
             shadow-lg transition"
        >
          Backup – pikchar.xyz
        </a>


        {loader || isDownloading ? (
          <div className='h-screen flex justify-center items-center'>
            <div className='w-48'>
              <Loader />
            </div>
          </div>
        ) : (
          <div className='max-w-5xl mx-auto px-4 py-12'>
            {/* Main Content Card */}
            <div className='bg-gradient-to-br from-gray-800/40 to-gray-900/40 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-gray-700/50'>
              {/* Header Section with Poster and Info */}
              <div className='flex flex-col md:flex-row gap-8 p-8 md:p-12'>
                {/* Poster */}
                <div className='flex-shrink-0 mx-auto md:mx-0'>
                  {loading ? (
                    <div className='w-56 h-80 md:w-72 md:h-[420px] rounded-xl'>
                      <Skeleton width='100%' height='100%' baseColor='#3F3F3F' />
                    </div>
                  ) : (
                    <img
                      src={myData?.poster}
                      alt={myData?.name || 'poster'}
                      className='w-56 h-80 md:w-72 md:h-[420px] object-cover rounded-xl shadow-2xl ring-4 ring-gray-700/50'
                    />
                  )}
                </div>

                {/* Movie Info */}
                <div className='flex-1 flex flex-col justify-center text-center md:text-left'>
                  {loading ? (
                    <>
                      <Skeleton height={60} width='90%' className='mb-6' baseColor='#3F3F3F' />
                      <Skeleton height={30} width='70%' className='mb-3' baseColor='#3F3F3F' />
                      <Skeleton height={30} width='70%' baseColor='#3F3F3F' />
                    </>
                  ) : (
                    <>
                      <h1 className='text-3xl md:text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent leading-tight'>
                        {myData?.name}
                      </h1>
                      <div className='space-y-3 mb-8'>
                        <div className='flex items-center gap-2 justify-center md:justify-start'>
                          <span className='text-yellow-400 text-sm font-semibold uppercase tracking-wider'>Genre:</span>
                          <p className='text-lg md:text-xl text-yellow-300/90 font-medium'>
                            {genreLabel}
                          </p>
                        </div>
                        <div className='flex items-center gap-2 justify-center md:justify-start'>
                          <span className='text-green-400 text-sm font-semibold uppercase tracking-wider'>Language:</span>
                          <p className='text-lg md:text-xl text-green-400/90 font-medium'>
                            {languageLabel}
                          </p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Divider */}
              <div className='h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent'></div>

              {/* Download Section */}
              <div className='p-8 md:p-12'>
                <div className='text-center max-w-2xl mx-auto'>


                  <h2 className='text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent'>
                    Ready to Download
                  </h2>
                  <p className='text-gray-300 text-lg mb-10'>
                    Your content is ready. Click the button below to start downloading
                  </p>

                  {!downloadResponse && (
                    <button
                      onClick={handleTokenDownload}
                      disabled={isDownloading}
                      className='bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold px-16 py-5 rounded-xl transition-all shadow-xl shadow-green-600/30 text-xl disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-4 mx-auto transform hover:scale-105 duration-200'
                    >
                      {isDownloading ? (
                        <>
                          <div className='animate-spin rounded-full h-7 w-7 border-b-3 border-white'></div>
                          Processing...
                        </>
                      ) : (
                        <>
                          <FaDownload className='text-2xl' />
                          Download Now
                        </>
                      )}
                    </button>
                  )}

                  {downloadResponse && (
                    <div className={`mt-8 p-8 rounded-xl shadow-xl ${downloadResponse.error ? 'bg-gradient-to-br from-red-900/60 to-red-800/60 border-2 border-red-500/50' : 'bg-gradient-to-br from-green-900/60 to-emerald-900/60 border-2 border-green-500/50'}`}>
                      {downloadResponse.error ? (
                        <>
                          <div className='bg-red-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4'>
                            <span className='text-white text-3xl font-bold'>✗</span>
                          </div>
                          <h4 className='text-2xl font-bold mb-3 text-red-300'>Download Failed</h4>
                          <p className='text-red-200 mb-6 text-lg'>{downloadResponse.message}</p>
                          <button
                            onClick={handleTokenDownload}
                            className='bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-4 rounded-lg transition-all shadow-lg'
                          >
                            Try Again
                          </button>
                        </>
                      ) : (
                        <>
                          <div className='bg-green-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4'>
                            <span className='text-white text-3xl font-bold'>✓</span>
                          </div>
                          <h4 className='text-2xl font-bold mb-3 text-green-300'>Success!</h4>
                          <p className='text-green-200 text-lg mb-2'>{downloadResponse.message}</p>
                          <p className='text-sm text-gray-300 mt-3 italic'>Your download should start automatically...</p>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {modalOpen && (
          <Modal statusCode={responseCode} onClose={() => setModalOpen(false)} />
        )}
      </div>
    );
  }

  // Original full view (when no SID token)
  return (
    <div>
      <a
        href="https://pikchar.xyz"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed top-4 right-4 z-[9999]
             bg-purple-600 text-white
             px-4 py-2 rounded-md
             text-sm md:text-base font-semibold
             hover:bg-purple-700
             shadow-lg transition"
      >
        Backup – pikchar.xyz
      </a>

      {loader ? (
        <div className='h-screen flex justify-center items-center'>
          <div className=' w-48'>
            <Loader />
          </div>
        </div>
      ) : (
        <div className='text-white'>
          <span className='absolute z-10 bottom-0 right-0 md:p-14 p-1'>
            <div className="group relative">
              <button className=' flex flex-col justify-center items-center text-[9px] gap-1'>
                < AiOutlineQuestionCircle
                  className=" md:text-4xl text-3xl max-sm:text-xl hover:scale-125 duration-200  " />
                Need help?
              </button>
              <span
                className="absolute -top-20 left-[45%] -translate-x-[50%] z-20 origin-left scale-0 px-10 rounded-lg    py-2 md:text-xl text-lg font-semibold shadow-md transition-all duration-300 ease-in-out group-hover:scale-100"
              > <div className=' flex flex-col gap-5'>
                  <a href="" className=" "> <GrInstagram /></a>
                  <a href="mailto:pikcharxdynamix@gmail.com" className=""><SiGmail /></a>
                </div>
              </span>
            </div>
          </span>

          <div className='relative flex'>
            {loading ? (
              <div className=' w-full h-screen'>
                <Skeleton
                  width='100%'
                  height='100%'
                  baseColor='black'
                  className='shimmer-placeholder'
                />
              </div>
            ) : (
              <img
                src={myData?.poster}
                alt={myData?.name || 'poster'}
                className=' h-screen w-full object-cover object-center blur-md '
              />
            )}
            <div className=' max-sm:hidden absolute inset-0 bg-gradient-to-r from-[#0C0404] to-transparent' />
            <div className='absolute inset-0 bg-gradient-to-t from-black to-transparent' />
          </div>

          <div className='pa top-0 md:mt-20 mt-10 md:ml-44 ml-0 p-5'>
            <div className='flex flex-row lg:gap-20 gap-8 mb-10'>
              <div>
                {loading ? (
                  <div className=' flex flex-row gap-10'>
                    <div className='md:w-[540px] md:h-auto lg:w-[520px] lg:h-[540px] sm:w-[520px] sm:h-[540px] w-[200px] h-[220px] rounded-lg'>
                      <Skeleton width='fit' height='100%' baseColor='#3F3F3F' />
                    </div>
                    <div className=' flex flex-col sm:gap-5 gap-5'>
                      <div className=' md:w-[540px] md:h-12 lg:w-[520px] lg:h-12 sm:w-[520px] sm:h-12 w-[100px] h-6 rounded-lg'>
                        <Skeleton width='fit' height='100%' baseColor='#3F3F3F' />
                      </div>
                      <div className='md:w-[480px] md:h-10 lg:w-[500px] lg:h-10 sm:w-[300px] sm:h-12 w-[80px] h-4 rounded-lg '>
                        <Skeleton width='fit' height='100%' baseColor='#3F3F3F' />
                      </div>
                      <div className='md:w-[440px] md:h-8 lg:w-[480px] lg:h-8 sm:w-[280px] sm:h-8 w-[85px] h-4 rounded-lg '>
                        <Skeleton width='fit' height='100%' baseColor='#3F3F3F' />
                      </div>
                    </div>
                  </div>
                ) : (
                  <img
                    src={myData?.poster}
                    alt=''
                    className='md:w-[540px] md:h-auto lg:w-[520px] lg:h-[540px] sm:w-[520px] sm:h-[540px] w-[220px] h-[240px] rounded-lg '
                  />
                )}
              </div>

              <div className=' flex flex-col w-[60%]'>
                {loading ? (
                  <>
                    <Skeleton height={50} width={'60%'} />
                    <Skeleton height={20} width={'40%'} />
                    <Skeleton height={20} width={'40%'} />
                    <Skeleton height={50} width={'20%'} />
                  </>
                ) : (
                  <>
                    <span className='font-bold tracking-tighter sm:mb-6 mb-5 md:text-5xl sm:text-2xl text-xl '>
                      {myData?.name}
                    </span>
                    <span className='font-semibold  sm:mb-2 mb-4 md:text-xl sm:text-base text-xs text-yellow-300'>
                      {genreLabel}
                    </span>
                    <span className='font-semibold  md:text-xl sm:text-base text-xs md:mb-10 mb-32 text-green-500'>
                      {languageLabel}
                    </span>
                  </>
                )}
                <div className=' max-sm:hidden'>
                  <div className=' flex flex-col lg:flex-row justify-start items-center gap-5'>
                    {myData?.quality && myData.quality.includes('h') && (
                      <div>
                        <button
                          className='font-semibold border-red-700 border-2 sm:w-32 sm:h-14 w-28 h-12 sm:text-lg text-sm rounded-md bg-red-700 hover:border-slate-100 hover:bg-transparent hover:scale-100 duration-200 ease-linear transform'
                          onClick={() => handleQualityClick('q1080')}>
                          1080p
                        </button>
                      </div>
                    )}
                    {myData?.quality && myData.quality.includes('m') && (
                      <div>
                        <button
                          className='page-button'
                          onClick={() => handleQualityClick('q720')}>
                          720p
                        </button>
                      </div>
                    )}
                    {myData?.quality && myData.quality.includes('l') && (
                      <div>
                        <button
                          className='page-button'
                          onClick={() => handleQualityClick('q480')}>
                          480p
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {myData?.seasons && myData?.episodes && (
                  <div className='absolute top-48 w-full flex flex-col items-start max-sm:hidden '>
                    <button
                      onClick={toggleSeasonList}
                      className=' w-44 h-12 bg-white bg-opacity-15 rounded tracking-wide font-semibold flex justify-center items-center gap-4'>
                      {selectedSeason !== null
                        ? `Season ${selectedSeason + 1}`
                        : 'Select Season'}{' '}
                      <IoIosArrowDown />
                    </button>

                    {isSeasonListVisible && (
                      <div className=' top-14 w-44 max-h-80 rounded overflow-y-auto bg-[#1D1D1D] bg-opacity-90 flex flex-col justify-start absolute z-20 cursor-pointer'>
                        <div
                          data-value='clear'
                          onClick={handleSeasonChange}
                          className=' text-white p-3 hover:scale-[1.04] transition-all ease-in-out'>
                          Select Season
                        </div>
                        {Array.from({ length: myData.seasons }).map(
                          (_, index) => (
                            <div
                              key={index}
                              data-value={index}
                              onClick={handleSeasonChange}
                              className=' text-white p-3 hover:scale-[1.04] transition-all ease-in-out'>
                              Season {index + 1}
                            </div>
                          )
                        )}
                      </div>
                    )}
                    {selectedSeason !== null &&
                      myData.episodes &&
                      myData.episodes[selectedSeason] && (
                        <div
                          className={`grid lg:grid-cols-5 sm:grid-cols-2  gap-4 mt-5 relative ${myData.episodes[selectedSeason] > 5 ? ' max-h-96 overflow-x-auto' : ''}`}>
                          {Array.from({
                            length: myData.episodes[selectedSeason],
                          }).map((_, index) => (
                            <button
                              key={index}
                              className='flex justify-center items-center mb-2 font-semibold text-sm border bg-[#1D1D1D] bg-opacity-100 border-gray-300 w-28 h-12 rounded-md hover:border-red-500 hover:bg-red-500 hover:scale-105 duration-200 ease-linear transform'
                              onClick={() =>
                                handleEpisodeClick(selectedSeason, index)
                              }>
                              Episode {index + 1}
                            </button>
                          ))}
                        </div>
                      )}
                  </div>
                )}
              </div>
            </div>

            {/* Phone view */}
            <div className=' flex flex-col lg:flex-row justify-start items-center gap-5 sm:hidden mt-10'>
              {myData?.quality && myData.quality.includes('h') && (
                <div>
                  <button
                    className='font-semibold border-red-700 border-2 sm:w-32 sm:h-14 w-28 h-12 sm:text-lg text-sm rounded-md bg-red-700 hover:border-slate-100 hover:bg-transparent hover:scale-100 duration-200 ease-linear transform'
                    onClick={() => handleQualityClick('q1080')}>
                    1080p
                  </button>
                </div>
              )}
              {myData?.quality && myData.quality.includes('m') && (
                <div>
                  <button
                    className='page-button'
                    onClick={() => handleQualityClick('q720')}>
                    720p
                  </button>
                </div>
              )}
              {myData?.quality && myData.quality.includes('l') && (
                <div>
                  <button
                    className='page-button'
                    onClick={() => handleQualityClick('q480')}>
                    480p
                  </button>
                </div>
              )}
            </div>

            {myData?.seasons && myData?.episodes && (
              <div className=' flex flex-col justify-center ml-0  items-center sm:hidden mb-20 '>
                <button
                  onClick={toggleSeasonList}
                  className=' w-40 h-10 text-sm mb-2  bg-white bg-opacity-15 rounded tracking-wide font-semibold flex justify-center items-center gap-5 '>
                  {selectedSeason !== null
                    ? `Season ${selectedSeason + 1}`
                    : 'Select Season'}{' '}
                  <IoIosArrowDown />
                </button>

                {isSeasonListVisible && (
                  <div className='max-[375px]:top-[380px] top-[360px] w-40 max-h-80  rounded overflow-y-auto bg-[#1D1D1D] bg-opacity-90 flex flex-col justify-start absolute z-20 '>
                    <div
                      data-value='clear'
                      onClick={handleSeasonChange}
                      className='   text-white p-3 hover:scale-105 duration-200 ease-linear hover:bg-[#333333] transform hover:underline font-semibold block w-44 h-12 bg-[#1D1D1D] bg-opacity-30 cursor-pointer text-base text-left'>
                      Select Season
                    </div>
                    {myData.episodes.map((_, index) => (
                      <div
                        key={index}
                        data-value={index}
                        onClick={handleSeasonChange}
                        className='text-white p-3 hover:scale-105 duration-200 ease-linear transform hover:bg-[#333333] hover:underline font-semibold block w-44 h-12 bg-[#1D1D1D] bg-opacity-30 cursor-pointer text-base text-left'>
                        Season {index + 1}
                      </div>
                    ))}
                  </div>
                )}

                {selectedSeason !== null && (
                  <div className="relative">
                    <div
                      className={`grid lg:grid-cols-5 sm:grid-cols-3 grid-cols-2 gap-4 mt-2 relative ${myData.episodes[selectedSeason] > 12 ? ' max-h-96 max-[375px]:h-72 overflow-y-auto ' : ''}`}>
                      {Array.from({
                        length: myData.episodes[selectedSeason],
                      }).map((_, episodeIndex) => (
                        <div
                          key={episodeIndex}
                          onClick={() =>
                            handleEpisodeClick(selectedSeason, episodeIndex)
                          }
                          className='flex justify-center items-center mb-2 font-semibold text-sm border bg-[#1D1D1D] bg-opacity-100 border-gray-300 w-28 h-12 rounded-md hover:border-red-500 hover:bg-red-500 hover:scale-105 duration-200 ease-linear transform'>
                          <button>
                            <span>Episode {episodeIndex + 1}</span>
                          </button>
                        </div>
                      ))}
                    </div>
                    {myData.episodes[selectedSeason] > 12 && (
                      <>
                        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black to-transparent pointer-events-none"></div>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {showButtons && (
            <div ref={scrollRef} className=' md:ml-28  mb-0 '>
              <div className=' flex justify-center items-center ms-10 me-10 mb-10 font-semibold sm:text-2xl  mt-10 text-center'>
                <span className=' flex flex-col justify-center items-center'>
                  {myData?.name}  {getQualityDisplay(selectedQuality)}
                  {myData?.seasons && (
                    <span>
                      Season-{(selectedSeason ?? 0) + 1} Episode-{(selectedEpisodes ?? 0) + 1}
                    </span>
                  )}{' '}
                </span>
              </div>
              <div className='flex justify-center items-center ms-10 me-10 mb-10 font-semibold sm:text-2xl mt-10 text-center'>
                <span className='flex flex-col justify-center items-center gap-2'>
                  <span>How to watch/download?</span>

                  <button
                    onClick={() => setShowGuide(true)}
                    className="text-blue-400 underline hover:text-blue-300 text-lg"
                  >
                    👉 Click here to view guide
                  </button>
                </span>
              </div>
              {showGuide && (
                <div
                  className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
                  onClick={() => setShowGuide(false)}   // 👈 click outside closes
                >
                  <div
                    className="bg-gray-900 p-4 rounded-lg relative max-w-lg"
                    onClick={(e) => e.stopPropagation()} // 👈 prevents closing when clicking image
                  >
                    {/* Close Button */}
                    <button
                      onClick={() => setShowGuide(false)}
                      className="absolute top-2 right-2 text-white text-xl hover:scale-110"
                    >
                      ✕
                    </button>

                    <img
                      src="https://i.ibb.co/RGL6Fwzh/ezgif-7ff1f6c30c587654.gif"
                      alt="How to watch or download"
                      className="rounded-md max-h-[80vh] object-contain"
                    />
                  </div>
                </div>
              )}
              <div className=' flex justify-center flex-row  items-center sm:gap-20 gap-10   '>
                <button
                  className=' font-semibold  border-2 sm:w-44 px-2 h-12  text-sm rounded-md border-white bg-white  text-black hover:bg-transparent hover:text-white hover:scale-105 duration-200 ease-linear transform flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed'
                  onClick={() => handleModalAction('watch')}
                  disabled={loadingAction !== null}
                >
                  {loadingAction === 'watch' ? (
                    <>
                      <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-black'></div>
                      Processing...
                    </>
                  ) : (
                    <>
                      <FaPlay className='text-sm' /> Watch Now
                    </>
                  )}
                </button>

                <button
                  className=' font-semibold  border-2 sm:w-44 px-2 h-12  text-sm rounded-md border-red-600 bg-red-600  text-white hover:bg-transparent hover:text-white hover:border-white hover:scale-105 duration-200 ease-linear transform flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed'
                  onClick={() => handleModalAction('download')}
                  disabled={loadingAction !== null}
                >
                  {loadingAction === 'download' ? (
                    <>
                      <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white'></div>
                      Processing...
                    </>
                  ) : (
                    <>
                      <FaDownload className='text-sm' /> Download
                    </>
                  )}
                </button>
              </div>

              {showRedirectButton && redirectUrl && (
                <div className='flex justify-center items-center mt-8 mb-6'>
                  <div className='bg-gradient-to-br from-yellow-900/60 to-orange-900/60 border-2 border-yellow-500/50 rounded-xl p-6 sm:p-8 max-w-md mx-4'>
                    <div className='text-center'>
                      <div className='bg-yellow-500 w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4'>
                        <span className='text-white text-2xl sm:text-3xl font-bold'>!</span>
                      </div>
                      <h4 className='text-xl sm:text-2xl font-bold mb-2 sm:mb-3 text-yellow-300'>Popup Blocked</h4>
                      <p className='text-yellow-200 mb-4 sm:mb-6 text-sm sm:text-base'>
                        Your browser blocked the automatic redirect. Click the button below to continue.
                      </p>

                      <button
                        onClick={() => {
                          window.open(redirectUrl, '_blank', 'noopener,noreferrer');
                          setShowRedirectButton(false);
                        }}
                        className='bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-lg transition-all shadow-xl inline-flex items-center gap-2 sm:gap-3 transform hover:scale-105 duration-200 text-sm sm:text-base'
                      >
                        <FaPlay className='text-base sm:text-xl' />
                        Continue to Content
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className='flex justify-center items-center mb-0 px-2'>
                <div className=' text-white sm:px-6 py-6 px- rounded-lg shadow-md'>
                  <table className=' divide-y divide-gray-700'>
                    <thead>
                      <tr>
                        <th className='sm:px-6 px-2 py-3 text-left sm:text-xs text-[10px] font-medium text-gray-400 uppercase tracking-wider'>
                          Notice
                        </th>
                        <th className='sm:px-6 px-2 py-3 text-left sm:text-xs text-[10px] font-medium text-gray-400 uppercase tracking-wider'>
                          Watch Now
                        </th>
                        <th className='sm:px-6 py-3 text-left sm:text-xs text-[10px] font-medium text-gray-400 uppercase tracking-wider'>
                          Download
                        </th>
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-700'>
                      <tr>
                        <td className='sm:px-6 px-2 py-4 sm:text-base text-sm '>
                          Change Subtitles
                        </td>
                        <td className=' '>
                          <span className='text-red-500 flex items-center justify-center w-full '>
                            ✗
                          </span>
                        </td>
                        <td className=' '>
                          <span className='text-green-500 flex items-center justify-center w-full'>
                            ✓
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className='sm:px-6 px-2 py-4 sm:text-base text-sm '>
                          Change Language
                        </td>
                        <td className=''>
                          <span className='text-red-500 flex items-center justify-center w-full'>
                            ✗
                          </span>
                        </td>
                        <td className=' '>
                          <span className='text-green-500 flex items-center justify-center w-full'>
                            ✓
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className='sm:px-6 px-2 py-4 sm:text-base text-sm '>
                          All Audio Supported
                        </td>
                        <td className=' '>
                          <span className='text-red-500 flex items-center justify-center w-full'>
                            ✗
                          </span>
                        </td>
                        <td className=' '>
                          <span className='text-green-500 flex items-center justify-center w-full'>
                            ✓
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className='sm:px-6 px-2 py-4 sm:text-base text-sm '>
                          All Video Supported
                        </td>
                        <td className=' '>
                          <span className='text-red-500 flex items-center justify-center w-full'>
                            ✗
                          </span>
                        </td>
                        <td className=' '>
                          <span className='text-green-500 flex items-center justify-center w-full'>
                            ✓
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>

              {/* <div className=' '>
                <p className=' text-center ms-4 me-4 text-sm mb-4 font-semibold'>
                  Play downloaded movies & series using below players
                </p>
                <div className=' text-center items-center flex flex-col mb-6 '>
                  <a
                    href={`https://www.smplayer.info/en/downloads`}
                    target='#'
                    className='page-button w-36 h-12 text-sm text-white font-bold py-2 px-4 rounded inline-flex items-center mb-2'>
                    <TbDownload className='mr-2 text-2xl' /> Download
                  </a>
                  <p className=' font-semibold text-xs text-cemtre flex flex-row gap-1 items-center justify-center'>
                    Download SM video player for desktop
                    <span className=' flex flex-row gap-2 text-sm'>
                      {' '}
                      <FaApple /> <FaWindows /> <FaLinux />{' '}
                    </span>{' '}
                  </p>
                </div>
                <div className='flex justify-center sm:flex-row flex-col gap-5  mb-8 text-center'>
                  <div>
                    <a
                      href={`https://apps.apple.com/sg/app/pikchar/id6754800532`}
                      target='#'
                      className='page-button w-36 h-12 text-sm text-white font-bold py-2 px-4 rounded inline-flex items-center mb-2'>
                      <FaApple className='mr-2 text-2xl' />
                      App Store
                    </a>
                    <p className=' font-semibold text-xs'>Pikchar for IOS</p>
                  </div>
                  <div>
                    <a
                      href={`https://play.google.com/store/apps/details?id=com.gyanesh.mobiletalkies&hl=en_IN`}
                      target='#'
                      className='page-button w-[150px] h-12 text-sm font-bold py-2 px-4 rounded inline-flex items-center mb-2 text-black bg-white md:bg-transparent md:text-white'
                    >
                      <IoLogoGooglePlaystore className='mr-2 text-2xl' />
                      Play Store
                    </a>

                    <p className=' mb-10 md:mb-0 font-semibold text-xs'>Pikchar for Android</p>
                  </div>
                </div>
              </div> */}
            </div>
          )}

          {modalOpen && (
            <Modal statusCode={responseCode} onClose={() => setModalOpen(false)} />
          )}
        </div>
      )}
    </div>
  );
};

export default MainList;